import { IonButton } from "@ionic/react";
import { Colors, Icon } from "main";

export type ButtonEditProps = {
  onClick: () => void;
};

// TODO: Likely this will be refactored away and replaced by a generic <Button> component
export function ButtonEdit(props: ButtonEditProps) {
  const { onClick } = props;

  return (
    <IonButton
      fill="clear"
      size="small"
      onClick={onClick}
      style={{
        margin: 0,
        "--padding-bottom": 0,
        "--padding-top": 0,
        "--padding-start": 0,
        "--padding-end": 0,
      }}
    >
      <Icon name="Edit" color={Colors.blue500} />
    </IonButton>
  );
}
